import { useEffect, useRef } from 'react'

import { esumStore } from '@/pages/Esum/esumStore'
import { FetchState } from '@/types/enum'

const POLL_INTERVAL = 3000
const MAX_ATTEMPTS = 10

export const useCardPolling = () => {
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const clearCardTimer = () => {
    if (!timerRef.current) return

    clearInterval(timerRef.current)
    timerRef.current = null
  }

  useEffect(() => clearCardTimer, [])

  const startPolling = () => {
    clearCardTimer()
    let attempts = 0

    timerRef.current = setInterval(async () => {
      if (++attempts > MAX_ATTEMPTS) {
        esumStore.fetchState = FetchState.rejected
        return clearCardTimer()
      }

      const hasCard = await esumStore.hasCard()
      if (hasCard) {
        clearCardTimer()
        esumStore.fetchOffer()
      }
    }, POLL_INTERVAL)
  }

  return { startPolling, clearCardTimer }
}
